import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import './Chips.component.css'
import { closeCircleOutline } from 'ionicons/icons'
import { IOption } from '../../common/common.types'

interface IChipsProps {
  chipsArray: any
  disableChips?: boolean // to disable all chips
  outline?: boolean
  handleClickOnChip?: (chip: any) => void
  handleChipDeletion?: (chip: any) => void
  showCrossBtn?: boolean
  className?: string
}

export type IChipsList = Array<any>
export interface IChip extends IOption {
  [x: string]: any
  disabled?: boolean
  color?: string
  tabLabel?: string
}

const Chips: React.FC<IChipsProps> = (props: IChipsProps) => {
  const {
    chipsArray,
    disableChips = false,
    outline = false,
    handleClickOnChip,
    handleChipDeletion,
    showCrossBtn = true,
    className = '',
  } = props

  const handleDeletion = (e: BaseSyntheticEvent, option: any) => {
    e.stopPropagation()
    if (handleChipDeletion) handleChipDeletion(option)
  }

  const handleClick = (e: BaseSyntheticEvent, option: any) => {
    e.stopPropagation()
    if (handleClickOnChip) {
      handleClickOnChip(option)
    }
  }

  return (
    <>
      {chipsArray.map((option: any) => (
        <IonChip
          outline={outline}
          data-testid={`Chip${option.id}`}
          key={`Chip_${option.id}${option.name}`}
          className={`${option.styles} ${className} m-2 common-chip-item`}
          style={{ backgroundColor: option.color ? option.color : 'var(--ion-color-primary' }}
          onClick={(e) => handleClick(e, option)}
          disabled={option?.disabled || disableChips ? true : false}>
          <IonLabel>{option.name}</IonLabel>
          {showCrossBtn && (
            <IonIcon color='white' icon={closeCircleOutline} onClick={(e) => handleDeletion(e, option)} />
          )}
        </IonChip>
      ))}
    </>
  )
}

export default Chips
